import ClientHttpService from "../util/ClientHttpService";
import {InputDropdownParameterDto} from "../dto/InputDropdownParameterDto";
import {UserMstDto} from "../dto/UserMstDto";
import {OtpRequestDto} from "../dto/OtpRequestDto";
import {ValidateOtpDto} from "../dto/ValidateOtpDto";
import ParamEncrypt from "../util/ParamEncrypt";
import HttpService from "../util/HttpService";

const CONTEXT_PATH = "/cwm/api/v2";
class SignupService {

    getSignup = () => {
        return ClientHttpService.get("/video/api/v2/user-access/menu-list");
    }
    getCommonDropdownList = (inputDropdownParameterDto: InputDropdownParameterDto) => {
        return ClientHttpService.post(CONTEXT_PATH.concat("/common-dropdown-service/list-item"), ParamEncrypt.encryptObjectWithEnvKey(inputDropdownParameterDto));
    }

    validateUsername = (username: string) => {
        return ClientHttpService.get(CONTEXT_PATH.concat("/user-mst-service/validate/").concat(ParamEncrypt.encryptDataWithEnvKey(username)));
    }

    validateAgentCode = (agentCode: string, username: string, isUpdateUser: boolean) => {
        return HttpService.get(CONTEXT_PATH.concat("/user-mst-service/validate/agent/").concat(ParamEncrypt.encryptData(agentCode) + "/").concat(isUpdateUser + "/").concat(ParamEncrypt.encryptData(username)));
    }

    createUser = (userMstDto: UserMstDto) => {
        return ClientHttpService.post(CONTEXT_PATH.concat("/user-mst-service"), ParamEncrypt.encryptObjectWithEnvKey(userMstDto));
    }

    generateOtp = (otpRequestDto: OtpRequestDto) => {
        return ClientHttpService.post(CONTEXT_PATH.concat("/otp-service/generate-sign-up-otp"), ParamEncrypt.encryptObjectWithEnvKey(otpRequestDto));
    }
    contactDetailChangeRequest = (otpRequestDto: OtpRequestDto) => {
        return ClientHttpService.post(CONTEXT_PATH.concat("/otp-service/change-request-otp-generate"), ParamEncrypt.encryptObjectWithEnvKey(otpRequestDto));
    }

    customerOriginalSeenOtp = (otpRequestDto: OtpRequestDto) => {
        return HttpService.post(CONTEXT_PATH.concat("/otp-service/customer-original-seen-otp"), ParamEncrypt.encryptObject(otpRequestDto));
    }
    validateOtp = (validateOtpDto: ValidateOtpDto) => {
        return ClientHttpService.post(CONTEXT_PATH.concat("/otp-service/validate"), ParamEncrypt.encryptObjectWithEnvKey(validateOtpDto));
    }

    getAllUserGroups = () => {
        return ClientHttpService.get(CONTEXT_PATH.concat("/user-mst-service/get-all-groups"));
    }

    getAllSalutation = () => {
        return HttpService.get(CONTEXT_PATH.concat("/user-mst-service/get-all-salutation"));
    }

    getAllReportingTo = () => {
        return HttpService.get(CONTEXT_PATH.concat("/user-mst-service/get-all-reporting-to"));
    }

    getAllAdminUserType = () => {
        return HttpService.get(CONTEXT_PATH.concat("/user-mst-service/get-all-admin-user-type"));
    }

    getAllUserType = () => {
        return HttpService.get(CONTEXT_PATH.concat("/user-mst-service/get-all-user-type"));
    }

    createAdminUsers = (userMstDto: UserMstDto) => {
        return ClientHttpService.post(CONTEXT_PATH.concat("/user-mst-service/create-admin-user"), ParamEncrypt.encryptObjectWithEnvKey(userMstDto));
    }

    updateAdminUsers = (userMstDto: UserMstDto) => {
        return ClientHttpService.post(CONTEXT_PATH.concat("/user-mst-service/update-admin-user"), ParamEncrypt.encryptObjectWithEnvKey(userMstDto));
    }

    getUserWiseDetails = (username: string) => {
        return HttpService.get(CONTEXT_PATH.concat("/user-mst-service/get-user-wise-details/").concat(ParamEncrypt.encryptData(username)));
    }

    userPasswordReset = (passwordDetailDto: object) => {
        return ClientHttpService.put(CONTEXT_PATH.concat("/user-mst-service/password-reset"), ParamEncrypt.encryptObjectWithEnvKey(passwordDetailDto));
    }

    getAllAdminUsers = () => {
        return ClientHttpService.get(CONTEXT_PATH.concat("/user-mst-service/get-all-admin-users"));
    }

}

const signupService = new SignupService();
export default signupService;
